module.exports = __webpack_public_path__ + "static/img/eat-type-item-01.ea39af74.png";